import * as CONST from "../../../app/constants"
import { fullName, isBranchApplication } from "../../../app/utils"
import { applicationData } from "../../../redux/selector/bltHomeSelector"
import { bltMortgageAdministratorReviewData } from "../../../redux/selector/BLTReviewData/administratorReviewData"
import { 
    bltCollectionAgencyBranchReviewData,
    bltCollectionAgencyReviewData
} from "../../../redux/selector/BLTReviewData/collectionsReviewData"
import { bltMortgageLenderReviewData } from "../../../redux/selector/BLTReviewData/lenderReviewData"
import { 
    bltMortgageBrokerageReviewData,
    bltMortgageBrokerReviewData,  
} from "../../../redux/selector/BLTReviewData/mortgageReviewData"
import { 
    bltAgentReviewData,
} from "../../../redux/selector/bltReviewSelector"
import { 
    // addAdditionalBranchApplication, 
    replaceAllAgentApplications, 
    resetAdditionalApplications, 
    // resetAdditionalBranchApplications, 
    setAdditionalApplications,
    setCurrentBranchApplicationId,
} from "../../../redux/slice/additionalApplicationsSlice"
import { applicationTypeFromLicenceSubType, isAgencyTypeApplication, isApplicationProcessed, isIndividualTypeApplication, isRenewalTypeApplication } from "../../../redux/slice/applicationsUtils"
import { fetchArchiveApplicationsForOriginalId } from "../../../redux/slice/archiveApplicationsSlice"
// import { setChangeReviewQueueItem } from "../../../redux/slice/bltChangeReviewSlice"
import { 
    fetchApplicationWithId, 
    fetchBranchApplicationsForPrimaryApplicationId, 
    fetchIndividualApplicationsForBusinessApplicationId,
    fetchPrincipalBrokerRenewalWithBusinessApplicationId,
    sendBrokerRenewalApplicationStatus
} from "../../../redux/slice/bltHomeSlice"
import { setQueueItem } from "../../../redux/slice/bltReviewSlice"
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice"
import { setAgencyApplication } from "../../../redux/slice/primaryAgencyApplicationSlice"

const getAppLockedBy = (application, userAuth) => (application.locked ? application.locked : userAuth.userData.email)

const getUpdatedQueueItem = (latestQueueItem, updatedApplicationData, userAuth, isReadOnly) => {
    // fetch the branches
    const nextStatus = (isReadOnly || (latestQueueItem.applicationStatus === CONST.APPLICATION_STATUS_PENDING)) 
                                            ? latestQueueItem.applicationStatus : CONST.APPLICATION_STATUS_UNDER_REVIEW

    const updatedQueueItem = Object.assign({}, latestQueueItem, {
        applicationStatus : nextStatus,
        businessLicenceData : updatedApplicationData,
        locked : getAppLockedBy(latestQueueItem, userAuth),
    })

    return updatedQueueItem
}

const handleBranchApplication = (
    application, 
    archiveApplication,
    userAuth, 
    isReadOnly, 
    dispatch
) => {
    const applicationData = {
        ...application.businessLicenceData,
        reviewDataCollectionDebt: bltCollectionAgencyBranchReviewData(application,archiveApplication)
    }

    const updatedQueueItem = getUpdatedQueueItem(
        application, applicationData, userAuth, isReadOnly)

    dispatch(setQueueItem(updatedQueueItem))
    dispatch(setAdditionalApplications({branchApplications: [updatedQueueItem]}))
    dispatch(setCurrentBranchApplicationId(updatedQueueItem.id))

    if(!isReadOnly)
        dispatch(saveBusinessLicenceApplicationData(
            applicationTypeFromLicenceSubType(application.licencingSubType), CONST.APPLICATION_MODE_NEW, true))
}

const handleCollectionAgencyApplication = (
    primaryApplication, 
    primaryApplicationArchive,
    branchApplications, 
    agentApplications,
    userAuth, 
    isReadOnly, 
    dispatch
) => {
    const prepareReviewData = (branchArchiveApplications) => {
        const applicationData = Object.assign({}, primaryApplication.businessLicenceData, {
            reviewDataCollectionDebt : bltCollectionAgencyReviewData(
                                        primaryApplication,primaryApplicationArchive, branchApplications, branchArchiveApplications, agentApplications)
        })
    
        const updatedQueueItem = getUpdatedQueueItem(
                                    primaryApplication, applicationData, userAuth, isReadOnly)
    
        dispatch(setQueueItem(updatedQueueItem))
        dispatch(setAgencyApplication(updatedQueueItem))

        if(!isReadOnly)
            dispatch(saveBusinessLicenceApplicationData(
                applicationTypeFromLicenceSubType(primaryApplication.licencingSubType)))
    }

    const idsForArchiveApplications = []
    branchApplications.forEach(app => {
        if(app.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL
            || app.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL) {
                idsForArchiveApplications.push(app.id)
            }
    })

    if(idsForArchiveApplications.length) {
        dispatch(fetchArchiveApplicationsForOriginalId(idsForArchiveApplications))
        .then(archiveApps => {
            prepareReviewData(archiveApps)
        })
    } else {
        prepareReviewData([])
    }
}

const handleCollectionAgencyAgentApplication = (latestQueueItem, appData, userAuth, isReadOnly, dispatch) => {
    const collectorApplicationData = Object.assign({}, appData, {
        reviewDataCollectionDebt : bltAgentReviewData(appData, latestQueueItem)
    })
    
    const updatedQueueItem = getUpdatedQueueItem(
                                latestQueueItem, collectorApplicationData, userAuth, isReadOnly)

    dispatch(setQueueItem(updatedQueueItem))
    dispatch(replaceAllAgentApplications([updatedQueueItem]))

    if(!isReadOnly)
        dispatch(saveBusinessLicenceApplicationData(
            applicationTypeFromLicenceSubType(latestQueueItem.licencingSubType)))
}

const handleMortgageAdministratorApplication = (latestQueueItem, archiveApplications, appData, userAuth, isReadOnly, dispatch) => {
    const applicationData = Object.assign({}, appData, {
        reviewDataCollectionDebt : bltMortgageAdministratorReviewData(latestQueueItem, archiveApplications)
    })

    const updatedQueueItem = getUpdatedQueueItem(
                                latestQueueItem, applicationData, userAuth, isReadOnly)

    dispatch(setQueueItem(updatedQueueItem))
    dispatch(setAgencyApplication(updatedQueueItem))

    if(!isReadOnly)
        dispatch(saveBusinessLicenceApplicationData(
            applicationTypeFromLicenceSubType(latestQueueItem.licencingSubType)))
}

const handleMortgageLenderApplication = (latestQueueItem, archiveApplications, appData, userAuth, isReadOnly, dispatch) => {
    const applicationData = Object.assign({}, appData, {
        reviewDataCollectionDebt : bltMortgageLenderReviewData(latestQueueItem, archiveApplications)
    })

    const updatedQueueItem = getUpdatedQueueItem(
                                latestQueueItem, applicationData, userAuth, isReadOnly)

    dispatch(setQueueItem(updatedQueueItem))
    dispatch(setAgencyApplication(updatedQueueItem))

    if(!isReadOnly)
        dispatch(saveBusinessLicenceApplicationData(
            applicationTypeFromLicenceSubType(latestQueueItem.licencingSubType)))
}

const handleIndividualMainAgentApplication = (latestQueueItem, archiveApplications, appData, userAuth, isReadOnly, dispatch) => {
    const applicationData = Object.assign({}, appData, {
        reviewDataCollectionDebt : bltMortgageBrokerReviewData(latestQueueItem, archiveApplications, latestQueueItem)
    })

    const updatedQueueItem = getUpdatedQueueItem(
                                latestQueueItem, applicationData, userAuth, isReadOnly)

    dispatch(setQueueItem(updatedQueueItem))
    dispatch(setAgencyApplication(updatedQueueItem))

    if(!isReadOnly)
        dispatch(saveBusinessLicenceApplicationData(
            applicationTypeFromLicenceSubType(latestQueueItem.licencingSubType)))
}

const handleMortgageAgencyApplication = (latestQueueItem, archiveApplications, appData, userAuth, isReadOnly, dispatch) => {
    const applicationData = Object.assign({}, appData, {
        reviewDataCollectionDebt : bltMortgageBrokerageReviewData(latestQueueItem, archiveApplications)
    })

    const updatedQueueItem = getUpdatedQueueItem(
                                latestQueueItem, applicationData, userAuth, isReadOnly)

    dispatch(setQueueItem(updatedQueueItem))
    dispatch(setAgencyApplication(updatedQueueItem))

    if(!isReadOnly)
        dispatch(saveBusinessLicenceApplicationData(
            applicationTypeFromLicenceSubType(latestQueueItem.licencingSubType)))
}

const handleMortgageBrokerApplication = (latestQueueItem, archiveApplications, appData, primaryApplication, userAuth, isReadOnly, dispatch) => {
    const applicationData = Object.assign({}, appData, {
        reviewDataCollectionDebt : bltMortgageBrokerReviewData(latestQueueItem, archiveApplications, primaryApplication)
    })

    const updatedQueueItem = getUpdatedQueueItem(
                                latestQueueItem, applicationData, userAuth, isReadOnly)

    dispatch(setQueueItem(updatedQueueItem))
    dispatch(replaceAllAgentApplications([updatedQueueItem]))

    if(!isReadOnly)
        dispatch(saveBusinessLicenceApplicationData(
            applicationTypeFromLicenceSubType(latestQueueItem.licencingSubType))) 
}

export const getApplicationById = (qItemId, isArchiveApplication) => async (dispatch, getState) => {
    dispatch(fetchApplicationWithId(qItemId, false, isArchiveApplication))
        .then(latestQueueItem => {
            if(latestQueueItem) {

                const fetchPromises = []

                if(isRenewalTypeApplication(latestQueueItem)) {
                    // TODO optimization possible : 
                    // all fetches done below are required to make the reviewDataCollectionDebt objet.
                    // If that object is already created, don't fetch any of the below data
                    fetchPromises.push(dispatch(fetchArchiveApplicationsForOriginalId(latestQueueItem.id)))

                    let targetLicenceSubType = undefined
                    if(latestQueueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL) {
                        targetLicenceSubType = [CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL,CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION]
                    } else if (latestQueueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL) {
                        targetLicenceSubType = [CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL,CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION]
                    }
    
                    if(targetLicenceSubType)
                        fetchPromises.push(dispatch(fetchIndividualApplicationsForBusinessApplicationId(
                            latestQueueItem.id,targetLicenceSubType, true)))
                }

                fetchPromises.push(dispatch(fetchBranchApplicationsForPrimaryApplicationId(
                    latestQueueItem.id, latestQueueItem.licencingSubType, true, isArchiveApplication)))

                Promise.all(fetchPromises)
                    .then(fetchResults => {

                        let archiveApplications, branchApplications, agentApplications = null

                        if(isRenewalTypeApplication(latestQueueItem)) {
                            archiveApplications = fetchResults[0][0]
                            agentApplications = fetchResults[1]
                            branchApplications = fetchResults[2]
                        } else {
                            branchApplications = fetchResults[0]
                        }

                        dispatch(resetAdditionalApplications())

                        dispatch(setAdditionalApplications({
                            branchApplications : branchApplications ?? [],
                            agentApplications : agentApplications ?? []
                        }))

                        const { userAuth } = getState()
                        const appData = applicationData(latestQueueItem)

                        if(appData) {
                            let isReadOnly = false

                            if(isApplicationProcessed(latestQueueItem)) 
                            { 
                                isReadOnly = true
                            }
                            else if(latestQueueItem.locked && 
                                (latestQueueItem.locked 
                                    !== (userAuth.userData.email)))
                            {
                                isReadOnly = (latestQueueItem.applicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW)
                            }

                            switch(latestQueueItem.licencingSubType) {  
                                case CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION:
                                case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION:
                                case CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL :
                                case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL :
                                    if(isBranchApplication(latestQueueItem)) {
                                        handleBranchApplication(
                                            latestQueueItem, archiveApplications, userAuth, isReadOnly, dispatch
                                        )
                                    } else {
                                        handleCollectionAgencyApplication(
                                            latestQueueItem, archiveApplications, branchApplications, agentApplications, userAuth, isReadOnly, dispatch) 
                                    }
                                    break
                                case CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION:
                                case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION : 
                                case CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL:
                                case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL : 
                                    handleCollectionAgencyAgentApplication(
                                        latestQueueItem, appData, userAuth, isReadOnly, dispatch)
                                    break
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION : 
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION :
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION :
                                    handleMortgageAgencyApplication(
                                        latestQueueItem, archiveApplications, appData, userAuth, isReadOnly, dispatch)
                                    break
                                case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION :
                                case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION :    
                                case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION :    
                                case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION :
                                    handleIndividualMainAgentApplication(
                                        latestQueueItem, archiveApplications, appData, userAuth, isReadOnly, dispatch);
                                    break;
                                case CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION : 
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION :
                                case CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION :
                                case CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION : 
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION :
                                case CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION :
                                    dispatch(fetchApplicationWithId(latestQueueItem.businessApplicationId))
                                        .then(primaryApplication => {
                                            //
                                            if(primaryApplication) {
                                                dispatch(setAgencyApplication(primaryApplication))
                                            }
                                            handleMortgageBrokerApplication(
                                                latestQueueItem, archiveApplications, appData, primaryApplication, userAuth, isReadOnly, dispatch)
                                        })
                                    
                                    break
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION : 
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION : 
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION : 
                                    handleMortgageLenderApplication(
                                        latestQueueItem, archiveApplications, appData, userAuth, isReadOnly, dispatch
                                    )
                                    break
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION : 
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION : 
                                case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION : 
                                    handleMortgageAdministratorApplication(
                                        latestQueueItem, archiveApplications, appData, userAuth, isReadOnly, dispatch
                                    )
                                    break
                                default : 
                                    // console.log("unknown licecing sub-type : " + latestQueueItem.licencingSubType)
                                    break
                            }
                        }
                    })
                    .catch(error => {
                        console.error({error})
                    })
            }

            return latestQueueItem
        })
}

export const mainTitle = (application) => { 

    let title = "Licence Application"

    switch(application?.licencingSubType) { 
        case CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION :
            if (isBranchApplication(application)) {
                title = "Add an Additional Branch"
            } else {
                title = "Licence application - Collection Agency"
            }
            break
        case CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL : 
            title = "Licence renewal application - Collection Agency"
            break
        case CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION : 
            title = "Licence application - Collector"
            break
        case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION :
            if (isBranchApplication(application)) {
                title = "Add an Additional Branch"
            } else { 
                title = "Licence application - Debt Management Agency"
            }
            break
        case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL : 
            title = "Licence renewal application - Debt Management Agency"
            break
        case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION : 
            title = "Licence application - Debt Management Agent"
            break
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION : 
            title = "Licence application - Mortgage Brokerage"
            break
        case CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION : 
            title = "Licence application - Principal Broker"
            break
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION : 
            title = "Licence application - Mortgage Broker"
            break
        case CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION : 
            title = "Licence application - Associate Mortgage Broker"
            break
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION : 
            title = "Licence application - Mortgage Lender"
            break
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION : 
            title = "Licence application - Mortgage Administrator"
            break
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION : 
            title = "Licence renewal application - Mortgage Brokerage"
            break
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION : 
            title = "Licence renewal application - Mortgage Lender"
            break
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION : 
            title = "Licence renewal application - Mortgage Administrator"
            break
        case CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION : 
            title = "Licence renewal application - Principal Mortgage Broker"
            break
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION : 
            title = "Licence renewal application - Mortgage Broker"
            break
        case CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION : 
            title = "Licence renewal application - Associate Mortgage Broker"
            break
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION :
            title = "Licence change request - Mortgage Brokerage"
            break;
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION :
            title = "Licence change request - Mortgage Lender"
            break;
        case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION :
            title = "Licence change request - Mortgage Administrator"
            break;
        case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION :
            title = "Licence application - Principal Broker"
            break;
        case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION :
            title = "Licence application - Principal Broker Change"
            break;
        case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION :
            title = "Licence application - Compliance Officer"
            break;
        case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION :
            title = "Licence application - Compliance Officer Change"
            break;
        default : 
            title = "Licence Application"
            break
    } 

    return title
}

export const mediumTitle = (application) => {
    const appData = application?.businessLicenceData ?? null 
    return appData?.businessName ?? ""
}

export const legalNameTitle = (application) => {
    const appData = application?.businessLicenceData ?? null
    return appData?.companyRjscDetails?.businessData?.businessOwner ?? ""
}

export const subTitle = (application) => { 

    let title = ""
    const appData = application?.businessLicenceData ?? null

    if(isAgencyTypeApplication(application) && !isBranchApplication(application)) {
        let contactHeading = "Business Contact"
        if(appData?.mainBusinessContact) {
            switch(applicationTypeFromLicenceSubType(application?.licencingSubType)) {
                case CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE :
                case CONST.APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE:
                case CONST.APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE:
                    contactHeading = "Principal Broker"
                    break
                case CONST.APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE :
                case CONST.APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE:
                case CONST.APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE: 
                    contactHeading = "Compliance Officer"
                    break
                case CONST.APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE : 
                    contactHeading = "Compliance Officer"
                    break
                default : 
                    contactHeading = "Business Contact"
                    break
            }

            title = `${fullName(appData?.mainBusinessContact)}, ${contactHeading}`
        }
    } else if(isIndividualTypeApplication(application)) { 
        title = fullName(appData?.personData)
    }

    return title
}

/**
 * 
 * If agency is approved and PB is also approved, then change all the
 * broker applications whose application status is PENDING_AGENCY_LICENCE to UNREAD
 * 
 * If agency is cancelled, rejected, etc. set PB, Broker status same as agency status.
 * 
 * @param {the application after review changes saved} agencyApplication 
 * @returns 
 */
export const handleMortgageBrokerageRenewalReview = (agencyApplication) => async(dispatch, getState) => {
    const { id, applicationStatus } = agencyApplication

    return dispatch(fetchPrincipalBrokerRenewalWithBusinessApplicationId(id))
        .then(pbApplication => {
            let finalStatus = applicationStatus
            let updateBrokerApplications = false
            let updatePBApp = false

            if(applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                // Agency is approved : 
                // if PB is also approved, then the broker and associate broker 
                // can be marked as UNREAD.
                if (pbApplication?.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                    updateBrokerApplications = true
                    finalStatus = CONST.APPLICATION_STATUS_UNREAD
                }
            } else if(applicationStatus === CONST.APPLICATION_STATUS_PENDING) {
                // don't do anything!
                updateBrokerApplications = false
                updatePBApp = false
            } else {
                // The agency application is not approved : 
                // Update PB and all other child applications with the status of 
                // the agency.
                updateBrokerApplications = true
                updatePBApp = true
            }
        
            if(updateBrokerApplications) {
                dispatch(sendBrokerRenewalApplicationStatus(finalStatus, id, updatePBApp))
                .then(data => {
                    // console.log("*** broker applications marked as", finalStatus, "***")
                    return data
                })
            }
        })
        .catch(console.error)
    
}

/**
 * 
 * If agency is approved and PB is also approved, then change all the
 * broker applications whose application status is PENDING_AGENCY_LICENCE to UNREAD
 * 
 * If agency is cancelled, rejected, etc. mark all PB, Broker as same.
 * 
 * @param {the application after review changes saved} pbApplication 
 * @returns 
 */
export const handleMortgagePrincipalBrokerRenewalReview = (pbApplication) => (dispatch, getState) => {
    const {businessApplicationId, applicationStatus} = pbApplication
    return dispatch(fetchApplicationWithId(businessApplicationId, true))
            .then(agencyApplication => {
                // console.log({agencyApplication})

                if(agencyApplication?.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED
                    && applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                        dispatch(sendBrokerRenewalApplicationStatus(CONST.APPLICATION_STATUS_UNREAD, businessApplicationId))
                            .then(data => {
                                // console.log("*** broker applications marked as UNREAD *** ")
                                return data
                            })
                } else {
                    // either agency is not approved yet or
                    // status of one of the applications is set to something else.
                    // console.log("agencyApplication.status", agencyApplication?.applicationStatus)
                }
            })
            .catch(console.error)
}

/* 
 * agency renewal processing  :
 *  - after agency is approved, 
 */
export const handlePostAgencyReviewProcess = (agencyApplication) => async (dispatch, getState) => {
    
    const primaryApplicationId = agencyApplication?.id
    const {applicationStatus, licenceStatus, licencingSubType} = agencyApplication

    // 1. get all the branches
    const { additionalApplications } = getState()
    const { 
        additionalBranchApplications, 
        agentApplications 
    } = additionalApplications

    const fetchPromises = []
    const payloadApplications = []

    const saveBranchAndIndividualApplications = (businessLiceneList) => {
        // 4. set the applicationStastus and licenceStatus to what 
        //    is set for the application.
        if(businessLiceneList.length) {
            // send the request back
            const {userAuth} = getState()
            const {csrfToken} = userAuth
        
            let headers = new Headers()
            headers.append('Content-Type',"application/json")
            headers.append("X-CSRF-TOKEN", csrfToken)
        
            return fetch(CONST.SAVE_APPLICATION_DATA_URL, {
                    method : 'POST',
                    headers: headers,
                    body : JSON.stringify(businessLiceneList)
                })
                .then(resp => resp.json())
                .then(data => {
                    // console.log(`${data.length} applications saved on server.`)
                })
                .catch(err => console.error(err))
        }
    }

    let needToFetchBranchData = false

    for (let i = 0; i < additionalBranchApplications.length; i++) {
        const branchApp = additionalBranchApplications[i]
        if(primaryApplicationId === branchApp.businessApplicationId 
            && !branchApp.businessLicenceData) {
            needToFetchBranchData = true        
            break
        }
    }

    if(needToFetchBranchData) {
        fetchPromises.push(dispatch(
            fetchBranchApplicationsForPrimaryApplicationId(primaryApplicationId, licencingSubType, true)))
    } else {
        additionalBranchApplications.forEach(branch => {
            if(primaryApplicationId === branch.businessApplicationId){
                if(isRenewalTypeApplication(branch)) {
                    payloadApplications.push({
                        ...branch, 
                        applicationStatus,
                        licenceStatus,
                        changeType : "SAVE" 
                    })
                } else if (branch.applicationStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY) {
                    if(applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                        // if agency renewal is approved
                        payloadApplications.push({
                            ...branch,
                            applicationStatus : CONST.APPLICATION_STATUS_UNREAD,
                            changeType : "SAVE"
                        })
                    } else if(applicationStatus === CONST.APPLICATION_STATUS_CANCELLED || 
                                applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT || 
                                applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED || 
                                applicationStatus === CONST.APPLICATION_STATUS_DENIED
                    ) {
                        payloadApplications.push({
                            ...branch,
                            applicationStatus,
                            licenceStatus,
                            changeType : "SAVE"
                        })
                    }
                }
            }
        })
    }

    // 2. get all the individual applications
    agentApplications.forEach(agentApp => {
        if (primaryApplicationId === agentApp.businessApplicationId 
            && !agentApp.businessLicenceData) {
            fetchPromises.push(dispatch(fetchApplicationWithId(agentApp.id, true)))
        }
    })

    if(fetchPromises.length) {
        // 3. get businessLicenceData for all of them, if its not there
        Promise.all(fetchPromises)
            .then(results => {
                results.forEach(application => {
                    if(primaryApplicationId === application.businessApplicationId) {

                        if(isRenewalTypeApplication(application)) {
                            if(application.applicationStatus === CONST.APPLICATION_STATUS_UNREAD
                                || application.applicationStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY
                                || application.applicationStatus === CONST.APPLICATION_STATUS_PENDING) {
                                // any individual application in UNREAD or PENDING_AGENCY status needs to be marked as 
                                // whatever the agency application status is. 

                                payloadApplications.push({
                                    ...application,
                                    applicationStatus,
                                    licenceStatus,
                                    changeType : "SAVE"
                                })
                            }
                        } else {
                            if(application.applicationStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY) {
                                // this use case is for the new individual applications filed at the time of renewal process.
                                if(applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                                    // if agency renewal is approved
                                    payloadApplications.push({
                                        ...application,
                                        applicationStatus : CONST.APPLICATION_STATUS_UNREAD,
                                        changeType : "SAVE"
                                    })
                                } else if(applicationStatus === CONST.APPLICATION_STATUS_CANCELLED || 
                                            applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT || 
                                            applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED || 
                                            applicationStatus === CONST.APPLICATION_STATUS_DENIED
                                ) {
                                    payloadApplications.push({
                                        ...application,
                                        applicationStatus,
                                        licenceStatus,
                                        changeType : "SAVE"
                                    })
                                } else if(applicationStatus === CONST.APPLICATION_STATUS_PENDING) {
                                    // do nothing?
                                } else {
                                    // what if the renewal agency application is rejected?
                                }
                            } else {
                                // do nothing!
                            }
                        }
                    }
                })

                saveBranchAndIndividualApplications(payloadApplications)
            })
            .catch(error => {
                console.error(error)
            })
        
    } else {
        saveBranchAndIndividualApplications(payloadApplications)
    }
}
